import React from "react";

const Box = ({ children, testid }) => (
  <div data-testid={testid} className="bg-white border border-slate-200 rounded-xl h-14 flex items-center justify-center gap-1 px-2 shadow-sm">
    {children}
  </div>
);

const AppleLogo = () => (
  <svg viewBox="0 0 384 512" className="h-5 w-auto" fill="#000">
    <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
  </svg>
);

const GoogleG = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5">
    <path fill="#4285F4" d="M23.52 12.27c0-.79-.07-1.54-.2-2.27H12v4.51h6.47a5.53 5.53 0 0 1-2.4 3.63v3h3.88c2.27-2.09 3.57-5.17 3.57-8.87z" />
    <path fill="#34A853" d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.88-3c-1.08.72-2.45 1.16-4.05 1.16-3.11 0-5.75-2.1-6.69-4.93H1.3v3.09A12 12 0 0 0 12 24z" />
    <path fill="#FBBC05" d="M5.31 14.32a7.2 7.2 0 0 1 0-4.64V6.59H1.3a12 12 0 0 0 0 10.82l4.01-3.09z" />
    <path fill="#EA4335" d="M12 4.75c1.76 0 3.34.61 4.58 1.8l3.43-3.43C17.95 1.19 15.24 0 12 0A12 12 0 0 0 1.3 6.59l4.01 3.09C6.25 6.85 8.89 4.75 12 4.75z" />
  </svg>
);

const Mastercard = () => (
  <svg viewBox="0 0 48 30" className="h-6 w-auto">
    <circle cx="19" cy="15" r="13" fill="#EB001B" />
    <circle cx="29" cy="15" r="13" fill="#F79E1B" />
    <path d="M24 5.3a12.9 12.9 0 0 1 0 19.4 12.9 12.9 0 0 1 0-19.4z" fill="#FF5F00" />
  </svg>
);

const CashLogo = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6">
    <rect x="2" y="6" width="20" height="12" rx="2.5" fill="#16A34A" />
    <circle cx="12" cy="12" r="3.2" fill="#fff" fillOpacity="0.95" />
    <circle cx="5.5" cy="12" r="1" fill="#fff" fillOpacity="0.7" />
    <circle cx="18.5" cy="12" r="1" fill="#fff" fillOpacity="0.7" />
  </svg>
);

const ORDER = ["visa", "mastercard", "klarna", "paypal", "applepay", "googlepay", "bitcoin", "cash"];

const LOGOS = {
  visa: <span className="text-[#1A1F71] font-black italic text-lg tracking-tight leading-none">VISA</span>,
  mastercard: <Mastercard />,
  klarna: <span className="bg-[#FFB3C7] text-black font-bold text-[13px] px-1.5 py-0.5 rounded-md leading-none">Klarna.</span>,
  paypal: <span className="font-black italic text-sm leading-none"><span className="text-[#003087]">Pay</span><span className="text-[#009CDE]">Pal</span></span>,
  applepay: <><AppleLogo /><span className="font-semibold text-slate-900 text-sm leading-none">Pay</span></>,
  googlepay: <><GoogleG /><span className="font-semibold text-slate-700 text-sm leading-none">Pay</span></>,
  bitcoin: <><span className="w-5 h-5 rounded-full bg-[#F7931A] text-white font-bold text-xs flex items-center justify-center leading-none">₿</span><span className="font-semibold text-slate-900 text-sm leading-none">Bitcoin</span></>,
  cash: <><CashLogo /><span className="font-semibold text-slate-900 text-sm leading-none">Kesh</span></>,
};

export default function PaymentMethods({ methods }) {
  const selected = ORDER.filter((k) => Array.isArray(methods) && methods.includes(k));
  if (!selected.length) return null;
  return (
    <div className="grid grid-cols-4 gap-2">
      {selected.map((k) => (
        <Box key={k} testid={`pay-${k}`}>{LOGOS[k]}</Box>
      ))}
    </div>
  );
}
